import { GET_DICOM_RECORDS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';
import { DicomRecord } from './setDicomRecord';

interface Response {
    dicoms: DicomDocument[];
    next_token: string;
}

export interface DicomDocument extends DicomRecord {
    loc: string;
    key: string;
    created_at: number;
    patient_data: PatientData;
    accession_number: string;
}

export interface PatientData {
    first_name: string;
    last_name: string;
    dob: string;
}

export default (uuid: string, next_token?: string): Promise<Response> => {
    return fetchWithRefresh(GET_DICOM_RECORDS(uuid, next_token)).then((res) => res.json());
};
